import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloPartenaire,cleanAloPartenaire } from '@/models/alo/AloPartenaire'

export default {
  getAllPartenaires(): AxiosPromise<AlrContainer<Array<AloPartenaire>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/api/admin/Partenaire`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloPartenaire>>
      }]
    })
  },
  getPartenaire(id:number):AxiosPromise<AlrContainer<AloPartenaire>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/Partenaire/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloPartenaire>
      }]
    })
  },
  savePartenaire(partenaire:AloPartenaire):AxiosPromise<AlrContainer<AloPartenaire>> {
    cleanAloPartenaire(partenaire)
    if(partenaire.id) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/api/admin/Partenaire/${partenaire.id}`, 
        method: 'PUT',
        data: partenaire,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloPartenaire>
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/api/admin/Partenaire`, 
        method: 'POST',
        data: partenaire,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloPartenaire>
        }]
      })    
    }
  },
  deletePartenaire(id:number){
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/Partenaire/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<number>
      }]
    })
  }
}